export default __webpack_public_path__ + "static/media/sangja.2575ed23.png";